import { render, staticRenderFns } from "./QuestionQuizFullPageSplitScreen.vue?vue&type=template&id=fbca8f50&scoped=true"
import script from "./QuestionQuizFullPagev1.js?vue&type=script&lang=js&external"
export * from "./QuestionQuizFullPagev1.js?vue&type=script&lang=js&external"
import style0 from "./QuestionQuizFullPageSplitScreen.vue?vue&type=style&index=0&id=fbca8f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbca8f50",
  null
  
)

export default component.exports